import { useTranslation } from "@/hooks/useTranslation";
import { useRefreshPlayerPrices } from "@/services";
import { Button, Icon } from "@st-marketplace/ui";

/** Fetches the price of the selected cards from fut.gg right now. */
export const RefreshPriceButton = ({
	resourceIds,
	onSuccess,
}: {
	resourceIds: number[];
	onSuccess?: () => void;
}) => {
	const { t } = useTranslation();
	const refreshPrices = useRefreshPlayerPrices();

	return (
		<Button
			type="button"
			startIcon={<Icon name="price-tag-3-line" />}
			loading={refreshPrices.isPending}
			disabled={resourceIds.length === 0}
			onClick={() =>
				refreshPrices.mutate(
					{ body: { resource_ids: resourceIds } },
					{ onSuccess },
				)
			}
		>
			{t("admin.transferPlayers.refreshPrice")}
		</Button>
	);
};
